import { Card, CardContent, Icon, Typography } from "@material-ui/core";
import React from "react";

const manageClientsLegend = props => (
  <Card>
    <CardContent>
      <div style={{ marginBottom: "15px" }}>
        <Typography variant="subheading" gutterBottom>
          <strong>Client Status:</strong>
        </Typography>
        <div style={{ display: "block" }}>
          <div
            style={{
              display: "flex",
              marginBottom: "10px"
            }}
          >
            <Icon
              style={{
                color: "#00ce00",
                marginRight: "10px"
              }}
            >
              person_outline
            </Icon>
            <Typography> Active</Typography>
          </div>
          <div
            style={{
              display: "flex",
              marginBottom: "10px"
            }}
          >
            <Icon
              style={{
                color: "#fbbb00",
                marginRight: "10px"
              }}
            >
              person_outline
            </Icon>
            <Typography> Prospect</Typography>
          </div>
          <div
            style={{
              display: "flex",
              marginBottom: "10px"
            }}
          >
            <Icon style={{ color: "red", marginRight: "10px" }}>
              person_outline
            </Icon>
            <Typography> NA</Typography>
          </div>
        </div>
      </div>
      <div>
        <Typography variant="subheading" gutterBottom>
          <strong>App Status:</strong>
        </Typography>
        <div style={{ display: "block" }}>
          <div
            style={{
              display: "flex",
              marginBottom: "10px"
            }}
          >
            <Icon
              style={{
                color: "#00ce00",
                marginRight: "10px"
              }}
            >
              smartphone
            </Icon>
            <Typography>Info up to date</Typography>
          </div>
          <div
            style={{
              display: "flex",
              marginBottom: "10px"
            }}
          >
            <Icon
              style={{
                color: "#fbbb00",
                marginRight: "10px"
              }}
            >
              smartphone
            </Icon>
            <Typography>Registered</Typography>
          </div>
          <div
            style={{
              display: "flex",
              marginBottom: "10px"
            }}
          >
            <Icon style={{ color: "red", marginRight: "10px" }}>
              smartphone
            </Icon>
            <Typography>Invite Sent</Typography>
          </div>
        </div>
      </div>
      <div style={{ marginBottom: "15px" }}>
        <Typography variant="subheading" gutterBottom>
          <strong>Terror Status:</strong>
        </Typography>
        <div style={{ display: "block" }}>
          <div
            style={{
              display: "flex",
              marginBottom: "10px"
            }}
          >
            <Icon
              style={{
                color: "#fbbb00",
                marginRight: "10px"
              }}
            >
              warning
            </Icon>
            <Typography> Pending terror list check</Typography>
          </div>
          <div
            style={{
              display: "flex",
              marginBottom: "10px"
            }}
          >
            <Icon
              style={{
                color: "red",
                marginRight: "10px"
              }}
            >
              fingerprint
            </Icon>
            <Typography> Terror list warning</Typography>
          </div>
         
        </div>
      </div>
    </CardContent>
  </Card>
);

export default manageClientsLegend;



// WEBPACK FOOTER //
// ./src/components/ManageClientsLegend/ManageClientsLegend.jsx